<template>
  <div class="bottom">
    <div class="bt">
      <div class="btmain">
        <img class="logo" src="@/common/images/bottom/logo@2x.png" alt />
        <div class="ewm">
          <div class="ewmbox"></div>
        </div>
        <div class="infoList">
          <div class="lxfs">
            <div>
              <span class="span1">关于股宇宙</span>
            </div>
            <div style>
              <span class="span0 hoverHight" @click="$router.push('about')"
                >公司介绍</span
              >
            </div>
          </div>
          <div class="lxfs" style="margin-right: ">
            <div>
              <span class="span1">数据中心</span>
            </div>
            <div style>
              <span class="span0 hoverHight" @click="download">股宇宙数据库·多模方</span>
            </div>
            <div>
              <span class="span0 hoverHight" @click="download"
                >股宇宙数据库·银河model</span
              >
            </div>
            <div>
              <span class="span0 hoverHight" @click="download"
                >股宇宙数据库·黑洞model</span
              >
            </div>
            <div>
              <span class="span0 hoverHight" @click="download">股宇宙数据库·鸿儒版</span>
            </div>
          </div>
          <div class="lxfs">
            <div>
              <span class="span1">联系股宇宙</span>
            </div>
            <div>
              <span class="tel span0 noHight">400-9090-199</span>
            </div>
            <div>
              <span class="span0 noHight">服务时间：工作日 09:00 - 18:30</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bd">
      <div class="bd-cont">
        <span>公司地址：广东省深圳市罗湖区笋岗街道田贝社区洪湖二街50号新南滨大厦6层</span>
        <span>
          COPYRIGHT©2014股宇宙数据库技术（深圳）有限公司
          <a href="https://beian.miit.gov.cn/" target="_self">
            <img class="logo" src="@/common/images/bottom/image@2x.png" alt />
            粤ICP备2024293451号</a
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {};
  },
  methods: {
    download() {
      const link = document.createElement("a");
      link.href =
        "https://dexun-install-new.oss-cn-shenzhen.aliyuncs.com/GuyuzhouOfficial.exe";
      // link.click();
    },
  },
};
</script>
<style scoped>
.bottom {
  width: 100%;
  z-index: 100;
  position: relative;
  margin: auto;
}
.bt,
.bd {
  width: 100%;
}
.bt {
  overflow: hidden;
  background: #112f5d;
  padding-top: 26px;
  height: 226px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
}
.bd {
  background-color: #e96818;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.bd-cont {
  display: flex;
  justify-content: space-between;
  min-width: var(--content-min-width);
}
.bd-cont a {
  color: #ffffff;
  margin-left: 16px;
}
.bd-cont a img {
  width: 15px;
  height: 16px;
}
.btmain {
  width: var(--content-width);
  min-width: var(--content-min-width);
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
}
.btmain .logo {
  width: 242px;
  height: 177px;
}
.btmain .ewm {
  width: 1px;
  height: 160px;
  margin-left: 60px;
  padding: 0 60px;
  box-sizing: border-box;
  border: 1px solid #fff;
  opacity: 0.16;
  border-top: none;
  border-bottom: none;
  border-right: none;
}
.ewmbox {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: -1px;
}

.infoList {
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.lxfs {
  min-width: 200px;
}
.lxfs:first-child {
  min-width: 100px;
}
.lxfs div {
  overflow: hidden;
  text-align: left;
  display: flex;
  align-items: center;
}

.lxfs span {
  text-align: left;
  display: inline-block;
}
.lxfs .span0 {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  padding-bottom: 8px;
  color: #e6e6e6;
  cursor: pointer;
}
.lxfs .tel {
  font-size: 24px;
}
.lxfs .span1 {
  font-family: PingFang SC;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
  padding-bottom: 24px;
}
.lxfs:last-child .span1 {
  padding-bottom: 14px;
}

.bd span {
  height: 17px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 17px;
  color: #ffffff;
}
.bottom .hoverHight:hover {
  color: #fff;
}
.bottom .noHight {
  cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/components/Bottoms.vue